export default "__VITE_ASSET__2764187a__"